var _style, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsultantDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 546 545",
    style: {
      enableBackground: "new 0 0 546 545"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFEFEE;}\r\n\t.st1{fill:#FF5A60;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 546,
    height: 545
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274,503.6c-44.5-1.1-84.4-15.5-120.9-39.7c-13-8.6-24.8-19-37.3-28.4c-3.1-2.3-3.5-4.7-2.6-8.1 c4.4-17.4,14.8-30.7,28-42.2c33-28.7,71.8-43.6,114.9-48.1c41.2-4.3,79.8,3.6,114.9,26.1c26.8,17.1,47,40.6,62.8,67.9 c0.7,1.1,0.2,3.9-0.8,4.9c-33.5,30.8-72,52.4-116.7,61.8C302.4,500.7,288.1,501.7,274,503.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358,210.9c1,44.7-35.1,85.5-85.3,85.8c-47.7,0.3-85.3-37.9-85.7-85.6c-0.4-45.5,36-85.7,85.5-85.8 C321.5,125.3,358.8,165.2,358,210.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultantDefault);
export default __webpack_public_path__ + "static/media/consultantDefault.1de1b8c444cc94cf11951621c096574f.svg";
export { ForwardRef as ReactComponent };